import { Component, HostListener } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog.service';

interface Changes {
  origin: string;
  destination: string;
  title: string;
}

@Component({
  selector: 'app-leg-update-history',
  templateUrl: './leg-update-history.component.html',
  styleUrls: ['./leg-update-history.component.scss']
})
export class LegUpdateHistoryComponent {
  visibility: boolean = false;
  title: string = 'Leg History';
  legDate: string = '';
  legName: string;
  data: any;

  constructor(
    private readonly dialogService: DialogService,
  ) { }

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    if (this.dialogService.isTopMost(this)) {
      this.hide();
    }
  }

  hide() {
    this.visibility = false;
    this.dialogService.unregisterDialog(this);
  }

  show() {
    this.visibility = true;
    this.dialogService.registerDialog(this);
  }

  getDetails() {
    if (this.data) {
      const detailObjs = (Object.values(this.data) as Changes[])
        .reverse()
        .map((item, i) => ({...item, ...({title: i == 0 ? 'Updated Changes' : 'Previous'})}));
      return detailObjs;
    }
    return [];
  }

  disableSort() {
    return 0;
  }
}
